import { TOGGLE_ENTRY_STRATEGY, TOGGLE_ENTRY_STRATEGY_ERROR, TOGGLE_ENTRY_STRATEGY_SUCCESS } from './actionTypes';

export const toggleEntryStrategy = ({ token, updatedBy, id, active, history }) => {
  return {
    type: TOGGLE_ENTRY_STRATEGY,
    payload: { token, updatedBy, id, active, history },
  };
};

export const toggleEntryStrategySuccess = (message) => {
  return {
    type: TOGGLE_ENTRY_STRATEGY_SUCCESS,
    payload: message,
  };
};

export const toggleEntryStrategyFailure = (message) => {
  return {
    type: TOGGLE_ENTRY_STRATEGY_ERROR,
    payload: message,
  };
};
